import { ChangeEvent } from 'react';
import { MpTextField } from 'src/components';
import useTranslation from 'src/hooks/useTranslation';
import { translatePrefix } from '../../..';

function ReferralCodeTextField({
  value,
  onChange,
}: {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}) {
  const { tc, t } = useTranslation(translatePrefix);

  return (
    <MpTextField
      label={tc('phInputField', { fieldName: t('referralCode') })}
      value={value || ''}
      onChange={onChange}
    />
  );
}

export default ReferralCodeTextField;
